import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
const icons = { VideocamOutlinedIcon };

// ==============================|| MENU ITEMS - VIDEO MONITORING ||============================== //

const videoMonitoring = {
  id: 'group-video-monitoring',
  type: 'group',
  children: [
    {
      id: 'video-monitoring',
      title: 'Video Monitoring',
      type: 'collapse',
      icon: icons.VideocamOutlinedIcon,
      children: [
        {
          id: 'live-streaming',
          title: 'Live Streaming',
          type: 'item',
          url: '/live-streaming',
          icon: icons.VideocamOutlinedIcon
        },
        {
          id: 'report fatigue',
          title: 'Report Fatigue',
          type: 'item',
          url: '/report-fatigue',
          icon: icons.VideocamOutlinedIcon
        }
      ]
    }
  ]
};

export default videoMonitoring;
